var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.427,
    height: 12.427,
    viewBox: "0 0 12.427 12.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M13.356,3H5.071A2.071,2.071,0,0,0,3,5.071v8.285a2.071,2.071,0,0,0,2.071,2.071h8.285a2.071,2.071,0,0,0,2.071-2.071V5.071A2.071,2.071,0,0,0,13.356,3Zm-6.9,2.762A1.036,1.036,0,1,1,5.416,6.8,1.036,1.036,0,0,1,6.452,5.762Zm7.594,7.477a.753.753,0,0,1-.69.808H5.071L10.3,9.338a.476.476,0,0,1,.642,0l3.107,3.093Z",
    fill: "#006eff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.41a91627a2f0a87d2c0c5c712627a60b.svg";
export { ForwardRef as ReactComponent };